import React from "react";
import EventCard from "../EventCard/EventCard";



const UpcomingEvents = () => {

  return (
    <div className="event-card-wrapper">
      <EventCard/>
      <EventCard/>
    </div>
  );
};

export default UpcomingEvents;
